const Main = () => import("@/views/main.vue");
// tab切换
// const UserMain = () => import("@/views/user/userMain.vue");
// 列表
const Branch = () => import("@/views/branch");

// 详情

const Details = () => import("@/views/orderstock/detail.vue");


export default [
    {
        path: "/monitoringList",
        name: "monitoringList",
        component: Main,
        meta: {
            name: "网点管理",
            unfold: false, //是否可以被展开
            iconType: "usergroup-add"
        },
        redirect: {
            name: "monitoringList"
        },
        children: [
            {
                path: "monitoringList",
                name: "monitoringList",
                component: Branch,
                meta: {
                    name: "网点管理",
                    role:{},
                }
            },
            // {
            //     path: "deliveryDetails",
            //     name: "deliveryDetails",
            //     component: Details,
            //     meta: {
            //         name: "出库信息列表/详情",
            //         role:{},
            //     }
            // }
        ]
    }
];